import { render } from "./marketDetail.vue?vue&type=template&id=3e821b45&scoped=true"
import script from "./marketDetail.vue?vue&type=script&lang=js"
export * from "./marketDetail.vue?vue&type=script&lang=js"

import "./marketDetail.vue?vue&type=style&index=0&id=3e821b45&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e821b45"]])

export default __exports__